import Length from '../../../../source/js/shared/models/Geometry/Length';
import { MaximumDecimalPoints } from "@/Models/Validators/MaximumDecimalPoints";
import { MinimumValue } from "@/Models/Validators/MinimumValue";
import { MaximumValue } from "@/Models/Validators/MaximumValue";
import { IsoscelesTriangleConstraintValidator } from "@/Models/Validators/IsoscelesTriangleConstraintValidator";
import { ShapeConfigurationInterface } from './ShapeConfigurationInterface';
import { ShapeCategory } from '@/types/shapeCategories';
import AbstractShape, { Dimensions } from '../Shapes/AbstractShape';
import { ValidatorInterface } from '../Validators/ValidatorInterface';

export default class IsoscelesTriangleConfiguration implements ShapeConfigurationInterface {
	public hasNewValidators = true;

	get_dimension_keys(): string[] {
		return [
			'base',
			'height',
		];
	}

	get_modifier_keys(): string[] {
		return [];
	}

	get_maximum_dimensions( maximum_rectangle ): Record<string, Length> {
		return {
			base: maximum_rectangle.get_longest_side(),
			height: maximum_rectangle.get_longest_side(),
		};
	}

	get_labels(): Record<string, string> {
		const { width, height } = window.measurementSelectorVariables.i18n.dimensionNames;

		return {
			width,
			height,
		};
	}

	get_validators(): Record<string, Array<unknown>> {
		return {
			base: [ MaximumDecimalPoints, MinimumValue, MaximumValue ],
			height: [ MaximumDecimalPoints, MinimumValue, MaximumValue ],
		};
	}

	get_new_validators( instance: AbstractShape, minimum: number, maximums: Record<string, Length>, dimensions: Dimensions ): ValidatorInterface[] {
		return [
			new MaximumDecimalPoints( {
				field: 'isosceles-triangle-height',
				dimension: 'height',
				decimalPoints: 1,
				instance,
			} ),
			new MaximumDecimalPoints( {
				field: 'isosceles-triangle-base',
				dimension: 'base',
				decimalPoints: 1,
				instance,
			} ),
			new MaximumValue( {
				field: 'isosceles-triangle-base',
				dimension: 'base',
				instance,
				maximums,
			} ),
			new MinimumValue( {
				field: 'isosceles-triangle-base',
				dimension: 'base',
				minimum,
				instance,
			} ),
			new MinimumValue( {
				field: 'isosceles-triangle-height',
				dimension: 'height',
				minimum,
				instance,
			} ),
			new MaximumValue( {
				field: 'isosceles-triangle-height',
				dimension: 'height',
				instance,
				maximums,
			} ),
			new IsoscelesTriangleConstraintValidator( {
				field: 'isosceles-triangle-constraint',
				dimension: 'height',
				instance,
				maximums,
			} )
		];
	}

	get_category(): ShapeCategory {
		return 'straight';
	}
}
